import React, { useState } from 'react';

function Accordion({ title, content, quarterKey, accordionId, onTitleChange, onContentChange, isFinished, isAdmin }) {
    const [editedTitle, setEditedTitle] = useState(title);
    const [editedContent, setEditedContent] = useState(content);

    const handleTitleBlur = () => {
        if (editedTitle !== title) {
            onTitleChange(editedTitle, quarterKey, accordionId);
        }
    };

    const handleContentBlur = () => {
        if (editedContent !== content) {
            onContentChange(editedContent, quarterKey, accordionId);
        }
    };

    return (
        <div className='accordion-container'>
            <div className='custom-checkbox'>
                <input
                    type='checkbox'
                    id={`checkbox-${quarterKey}-${accordionId}`}
                    checked={isFinished}
                    readOnly
                />
                <label htmlFor={`checkbox-${quarterKey}-${accordionId}`}></label>
            </div>
            {isAdmin ? (
                <>
                    <textarea
                        className='textarea-title'
                        value={editedTitle}
                        onChange={e => setEditedTitle(e.target.value)}
                        onBlur={handleTitleBlur}
                    />
                    <textarea
                        className='textarea-content'
                        value={editedContent}
                        onChange={e => setEditedContent(e.target.value)}
                        onBlur={handleContentBlur}
                    />
                </>
            ) : (
                <>
                    <div className='readonly-title'>{`Mål: ${editedTitle}`}</div>
                    <div className='readonly-content'>{`Hvordan vi når Målet: ${editedContent}`}</div>
                </>
            )}
        </div>
    );
}

export default Accordion;



